import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { acceptMyInvitation } from "../../api/server";
import {
  notifyError,
  notifySuccess,
} from "../notifications/notificationsSlice";
import Auth from "../../api/auth";

const initialState = {
  registrationInProgress: false,
  invitationAccepted: false,
};
export const acceptInvitation = createAsyncThunk(
  "registration/acceptInvitation",
  acceptMyInvitation
);

const registrationSlice = createSlice({
  name: "registration",
  initialState: initialState,
  reducers: {
    setRegistrationInProgress(state, { payload }) {
      state.registrationInProgress = payload;
    },
  },
  extraReducers: {
    [acceptInvitation.fulfilled]: (state, { payload: { error } }) => {
      state.invitationAccepted = true;
      state.registrationInProgress = false;
      state.error = error;
    },
    [acceptInvitation.rejected]: (state, { payload: { error } }) => {
      state.error = error;
    },
  },
});

export const { setRegistrationInProgress } = registrationSlice.actions;

export default registrationSlice.reducer;

export const finishRegistration = createAsyncThunk(
  "registration/finishRegistration",
  async ({ tenantId, email, newPassword }, thunkAPI) => {
    thunkAPI.dispatch(setRegistrationInProgress(true));
    try {
      await Auth.signInWithLink(tenantId, email);
      await thunkAPI.dispatch(acceptInvitation(newPassword));
      await Auth.signOut();
      thunkAPI.dispatch(
        notifySuccess({
          title: "registration",
          message: "registration_success",
        })
      );
      thunkAPI.dispatch(setRegistrationInProgress(false));
    } catch (err) {
      const message =
        err.code === "auth/invalid-email" ||
        err.code === "auth/invalid-action-code" ||
        err.code === "auth/too-many-requests" ||
        err.code === "auth/argument-error"
          ? err.code
          : err.message;
      console.log(err);
      thunkAPI.dispatch(
        notifyError({ title: "registration", message: message })
      );
      thunkAPI.dispatch(setRegistrationInProgress(false));
    } finally {
    }
  }
);
